import { IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonRow, IonTitle, IonToast, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { alertCircle, arrowBack, calendarOutline, cartOutline, cashOutline, chevronForwardOutline, closeCircle, filterOutline, informationCircleOutline, printOutline, swapVerticalOutline, walletOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { gerarEscPos, gerarEscPosFechamentoCaixa } from '../../../../../Utils/EscPosGenerator';
import { adicionarImpressaoNaFila, criarJobImpressao } from '../../../../../Utils/PrintQueueHelper';
import { apiPedidosCaixaGeralLancamentosGET, apiPedidosCaixasFechamentoGET, apiPedidosCaixasGET, apiPedidosCaixasLancamentoPOST, apiPedidosCaixasPUT, mesaGerarCupom, projetoGerarCupom, requestService, urlBaseCore } from '../../../../../Utils/Services';
import CaixaGeralAbrir from '../CaixaGeralAbrir/CaixaGeralAbrir';
import './CaixaGeral.css';

const CaixaGeral: React.FC = () => {

  const history = useHistory();
  const [itens, setItens] = useState<any>([]);
  const [stateResultadoMesas, setStateResultadoMesas] = useState<any>([]);
  const [stateResultadoBalcao, setStateResultadoBalcao] = useState<any>([]);
  const [stateResultadoOrdens, setStateResultadoOrdens] = useState<any>([]);
  const [stateResultadoTotem, setStateResultadoTotem] = useState<any>([]);
  const consultaCaixa = useRef(0);
  const [resumoFinanceiro, setResumoFinanceiro] = useState<any>();
  const [saldoDinheiro, setSaldoDinheiro] = useState(0);
  const [stateTotal, setStateTotal] = useState<number>(0);
  const [stateTotalBalcao, setStateTotalBalcao] = useState<number>(0);
  const [stateTotalMesa, setStateTotalMesa] = useState<number>(0);
  const [stateTotalOrdens, setStateTotalOrdens] = useState<number>(0);
  const [stateTotalTotem, setStateTotalTotem] = useState<number>(0);
  const [stateDinheiro, setStateDinheiro] = useState<number>(0);
  // const [stateCartaoCredito, setStateCartaoCredito] = useState<number>(0);
  // const [stateCartaoDebito, setStateCartaoDebito] = useState<number>(0);
  // const [statePix, setStatePix] = useState<number>(0);
  // const [stateAlelo, setStateAlelo] = useState<number>(0);
  // const [stateSodexo, setStateSodexo] = useState<number>(0);
  // const [stateValeAlimentacao, setStateValeAlimentacao] = useState<number>(0);
  // const [stateBoleto, setStateBoleto] = useState<number>(0);
  // const [stateSemDefinicao, setStateSemDefinicao] = useState<number>(0);
  const [stateCaixas, setStateCaixas] = useState<any>([]);
  const [stateCaixaSelecionado, setStateCaixaSelecionado] = useState<any>({});

  const [statePagamentos, setStatePagamentos] = useState<{ [key: string]: number }>({});
  const [stateLancamentos, setStateLancamentos] = useState<any[]>([]);
  const [stateSaldoLancamentos, setStateSaldoLancamentos] = useState<number>(0);

  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [caixaAberto, setCaixaAberto] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  useEffect(() => { consultaCaixa.current++; setResumoFinanceiro(undefined); }, [loja]);

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const [showModal, setShowModal] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [showModalEntrada, setShowModalEntrada] = useState(false);
  const [showModalSaida, setShowModalSaida] = useState(false);
  const [showModalLancamentos, setShowModalLancamentos] = useState(false);

  // Navegação mobile (app nativo): alterna entre lista e detalhes
  const isMobileApp = !isPlatform('mobileweb') && isPlatform('mobile');
  const [mostrarDetalheMobile, setMostrarDetalheMobile] = useState(false);

  // Filtro por data (formato YYYY-MM-DD)
  const [dataFiltro, setDataFiltro] = useState<string | null>(null);
  const [showFiltroData, setShowFiltroData] = useState(false);
  const [dataFiltroTemp, setDataFiltroTemp] = useState<string>(new Date().toISOString());

  // Estados para Modal Entrada
  const [valorEntrada, setValorEntrada] = useState<string>('');
  const [descricaoEntrada, setDescricaoEntrada] = useState<string>('');
  const [alertaValorEntrada, setAlertaValorEntrada] = useState(false);
  const [alertaDescricaoEntrada, setAlertaDescricaoEntrada] = useState(false);

  // Estados para Modal Saída
  const [valorSaida, setValorSaida] = useState<string>('');
  const [descricaoSaida, setDescricaoSaida] = useState<string>('');
  const [alertaValorSaida, setAlertaValorSaida] = useState(false);
  const [alertaDescricaoSaida, setAlertaDescricaoSaida] = useState(false);

  const impressoraBluetoothHabilitar = window.localStorage.getItem("impressoraBluetoothHabilitar") === "true";
  const impressoraBluetoothSPPHabilitar = window.localStorage.getItem("impressoraBluetoothSPPHabilitar") === "true";
  const impressoraLocalHabilitar = window.localStorage.getItem("impressoraLocalHabilitar") === "true";
  const impressoraRedeHabilitar = window.localStorage.getItem("impressoraRedeHabilitar") === "true";

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarCaixas();
  });

  function carregarCaixas(data: string | null = null) {
    const consulta = ++consultaCaixa.current;
    setResumoFinanceiro(undefined);
    setShowLoading(true);
    const baseUrl = apiPedidosCaixasGET.url.replace("{id}", loja.replaceAll("#", "%23"));
    const urlComFiltro = data ? `${baseUrl}?data=${data}` : baseUrl;
    return requestService(
      urlComFiltro,
      {
        method: apiPedidosCaixasGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (consulta !== consultaCaixa.current) return;
        if (response) {
          setStateCaixas(response);
          //console.log('getCaixas', response);
          if (response.Items && response.Items[0]) {
            setStateCaixaSelecionado(response.Items[0]);
            carregarCaixaGeral(response.Items[0].sk);
          } else {
            setStateCaixaSelecionado({});
            setShowLoading(false);
          }
        } else {
          setShowLoading(false);
        }
      },
      (error: any) => {
        if (consulta !== consultaCaixa.current) return;
        console.log(error);
        setShowLoading(false);
      }
    )
  };

  function carregarCaixaGeral(filtro: any = null) {
    const consulta = ++consultaCaixa.current;
    setResumoFinanceiro(undefined);
    setShowLoading(true);
    return requestService(
      apiPedidosCaixaGeralLancamentosGET.url.replace("{id}", loja.replaceAll("#", "%23")).concat(filtro ? "?caixa=".concat(Buffer.from(filtro).toString('base64')) : ""),
      {
        method: apiPedidosCaixaGeralLancamentosGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (consulta !== consultaCaixa.current) return;
        if (response) {
          setItens(response.items);
          setStateResultadoMesas(response.retComanda);
          setStateResultadoBalcao(response.retBalcao);
          setStateResultadoOrdens(response.retOrdens);
          setStateResultadoTotem(response.retTotem);
          setResumoFinanceiro(response);
          setSaldoDinheiro(response.saldoDinheiro);
          setStateDinheiro(Number(response.totaisPorFormaDePagamento?.Dinheiro || 0));
          setStateTotal(response.total);
          setStateTotalBalcao(response.totalBalcao);
          setStateTotalMesa(response.totalMesa);
          setStateTotalOrdens(response.totalOrdens);
          setStateTotalTotem(response.totalTotem);

          // Processa lançamentos (entradas e saídas) do retCaixa
          const retCaixa = response.retCaixa || {};
          const lancamentos = retCaixa.lancamentos || [];

          setStateLancamentos(lancamentos);
          setStateSaldoLancamentos(response.saldoLancamentos);

          // setStateDinheiro(response.dinheiro);
          // setStateCartaoCredito(response.cartaoCredito);
          // setStateCartaoDebito(response.cartaoDebito);
          // setStatePix(response.pix);
          // setStateAlelo(response.alelo);
          // setStateSodexo(response.sodexo);
          // setStateValeAlimentacao(response.valeAlimentacao);
          // setStateBoleto(response.boleto);

          // console.log("boleto", response.boleto);
          // setStateSemDefinicao(response.semDefinicao);

          const pagamentos = response.totaisPorFormaDePagamento || {};

          console.log("pagamentos", pagamentos);

          const novoEstadoPagamentos: { [key: string]: number } = {};

          // Itera sobre as entradas do objeto e constrói o estado
          Object.entries(pagamentos).forEach(([nome, valor]) => {
            const valorNumerico = Number(valor);
            novoEstadoPagamentos[nome] = valorNumerico;

            // Verifica se o nome (em lowercase) é "dinheiro"
            if (nome.toLowerCase() === "dinheiro") {
              setStateDinheiro(valorNumerico);
            }
          });

          setStatePagamentos(novoEstadoPagamentos);

        }
      },
      (error: any) => {
        if (consulta !== consultaCaixa.current) return;
        setTextToast("Não foi possível carregar o resumo do caixa.");
        setShowToast(true);
      }
    ).finally(() => {
      if (consulta === consultaCaixa.current) setShowLoading(false);
    })
  };

  const mensagemFecharCaixa = () => {
    mostartAlerta({
      backdropDismiss: false,
      header: "Atenção!",
      message: "Você tem certeza que deseja fechar o caixa?",
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Confirmar',
          handler: async () => {


            fecharCaixa();

          }
        }
      ],
      onDidDismiss: () => { console.log('did dismiss'); }
    });
  };

  const fecharCaixa = () => {
    setShowLoading(true);

    let objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
    }

    requestService(
      apiPedidosCaixasPUT.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasPUT.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response.message && response.message.Attributes) {
          carregarCaixas();
        }
      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message);
        setShowToast(true);
      }
    ).finally(() => {
      setShowLoading(false);
    });
  };

  function onChangeValorEntrada(e: any) {
    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValorEntrada(v);
    setAlertaValorEntrada(false);
  }

  function onChangeValorSaida(e: any) {
    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValorSaida(v);
    setAlertaValorSaida(false);
  }

  const salvarEntrada = () => {
    let hasError = false;

    // Converte o valor formatado para número
    const valorNumerico = parseFloat(valorEntrada.replace(/\./g, '').replace(',', '.'));

    if (!valorEntrada || isNaN(valorNumerico) || valorNumerico <= 0) {
      setAlertaValorEntrada(true);
      hasError = true;
    } else {
      setAlertaValorEntrada(false);
    }

    if (!descricaoEntrada.trim()) {
      setAlertaDescricaoEntrada(true);
      hasError = true;
    } else {
      setAlertaDescricaoEntrada(false);
    }

    if (hasError) {
      return;
    }

    setShowLoading(true);

    const objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
      tipo: 'entrada',
      valor: valorNumerico,
      descricao: descricaoEntrada.trim()
    };

    requestService(
      apiPedidosCaixasLancamentoPOST.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasLancamentoPOST.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        setShowModalEntrada(false);
        setValorEntrada('');
        setDescricaoEntrada('');
        setAlertaValorEntrada(false);
        setAlertaDescricaoEntrada(false);
        carregarCaixas();
        setShowLoading(false);
      },
      (error: any) => {
        setTextToast(error.message || 'Erro ao registrar entrada');
        setShowToast(true);
        setShowLoading(false);
      }
    );
  };

  const salvarSaida = () => {
    let hasError = false;

    // Converte o valor formatado para número
    const valorNumerico = parseFloat(valorSaida.replace(/\./g, '').replace(',', '.'));

    if (!valorSaida || isNaN(valorNumerico) || valorNumerico <= 0) {
      setAlertaValorSaida(true);
      hasError = true;
    } else {
      setAlertaValorSaida(false);
    }

    if (!descricaoSaida.trim()) {
      setAlertaDescricaoSaida(true);
      hasError = true;
    } else {
      setAlertaDescricaoSaida(false);
    }

    if (hasError) {
      return;
    }

    setShowLoading(true);

    const objRequest = {
      loja: loja,
      pk: stateCaixaSelecionado.pk,
      sk: stateCaixaSelecionado.sk,
      tipo: 'saida',
      valor: valorNumerico,
      descricao: descricaoSaida.trim()
    };

    requestService(
      apiPedidosCaixasLancamentoPOST.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasLancamentoPOST.method,
        headers: [["token", window.localStorage.getItem("token")]],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
      history,
      (response: any) => {
        setShowModalSaida(false);
        setValorSaida('');
        setDescricaoSaida('');
        setAlertaValorSaida(false);
        setAlertaDescricaoSaida(false);
        carregarCaixas();
        setShowLoading(false);
      },
      (error: any) => {
        setTextToast(error.message || 'Erro ao registrar saída');
        setShowToast(true);
        setShowLoading(false);
      }
    );
  };

  function montarPayloadFechamentoCaixa() {
    const entradas = resumoFinanceiro.entradas;
    const saidas = resumoFinanceiro.saidas;
    const dinheiro = saldoDinheiro;

    return {
      caixa: stateCaixaSelecionado,
      lancamentos: stateLancamentos,
      pagamentos: statePagamentos,
      qualidade: resumoFinanceiro.qualidade,
      tiposVenda: {
        Balcão: stateTotalBalcao,
        Mesa: stateTotalMesa,
        [window.localStorage.getItem("servicoTipoPlural") || "Projetos"]: stateTotalOrdens,
        Totem: stateTotalTotem
      },
      totais: {
        vendas: stateTotal,
        recebido: resumoFinanceiro.recebido,
        emAberto: resumoFinanceiro.emAberto,
        recebidoAMais: resumoFinanceiro.recebidoAMais,
        abertura: resumoFinanceiro.abertura,
        lancamentos: stateSaldoLancamentos,
        dinheiro,
        entradas,
        saidas
      }
    };
  }

  async function gerarCupomFechamentoCaixa() {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof tkn === "string") { token = tkn; }

    const caixaBase64 = Buffer.from(stateCaixaSelecionado.sk).toString('base64');
    const url = `${apiPedidosCaixasFechamentoGET.url.replace("{id}", loja.replaceAll("#", "%23"))}?caixa=${caixaBase64}`;

    const resp = await fetch(url, {
      method: apiPedidosCaixasFechamentoGET.method,
      headers: [["token", token]],
      credentials: 'include'
    });

    const result = await resp.json();
    if (!result) {
      throw new Error("Ocorreu um erro ao gerar o fechamento.");
    }

    mostartAlerta({
      backdropDismiss: false,
      header: 'Gerar Fechamento',
      message: '<strong>Fechamento</strong> foi gerado com sucesso.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Visualizar',
          cssClass: 'primary',
          handler: () => {
            window.open(result, '_blank');
          }
        }
      ]
    });
  }

  async function imprimirFechamentoCaixa() {
    if (!stateCaixaSelecionado?.sk) {
      setTextToast("Selecione um caixa para imprimir o fechamento.");
      setShowToast(true);
      return;
    }

    const fechamento = montarPayloadFechamentoCaixa();
    const comandosEscPos = gerarEscPosFechamentoCaixa(
      fechamento,
      dadosEmpresa,
      dadosEmpresa?.impressoraLargura === "58",
      dadosEmpresa?.tamanhoFonte === "grande"
    );

    if (comandosEscPos) {
      const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

      let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
      let config: any = {};

      if (impressoraRedeHabilitar && mobile) {
        tipo = 'rede';
        config = { ip: dadosEmpresa?.impressoraRedeIp, porta: dadosEmpresa?.impressoraRedePorta };
      } else if (impressoraLocalHabilitar && !mobile) {
        tipo = 'local';
        config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
      } else if (impressoraBluetoothHabilitar && mobile) {
        tipo = 'ble';
        config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
      } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
        tipo = 'spp';
        config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
      }

      if (tipo) {
        const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
          comandosEscPos,
          dados: fechamento,
          impressoraConfig: config,
          tipo,
          quantidadeVias: dadosEmpresa?.impressaoDuasVias ? 2 : 1,
          origem: 'CaixaGeral:imprimirFechamento'
        }));

        if (adicionado) {
          return;
        }
      }
    }

    try {
      setShowLoading(true);
      await gerarCupomFechamentoCaixa();
    } catch (error: any) {
      console.error("Erro ao gerar fechamento:", error);
      setTextToast(error.message || "Ocorreu um erro ao gerar o fechamento.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }


  async function closeModal() {
    setShowModal(false);
  }

  async function closeModalSuccess() {
    carregarCaixas();
    setShowModal(false);
  }

  function readListaDetalhes() {
    return (
      <section className="caixa-detalhes-grid" aria-label="Registros do caixa">
        <div className="caixa-detalhes-heading">
          <h2>Registros do caixa <span>{itens.length}</span></h2>
          <p>Selecione uma linha para imprimir o comprovante.</p>
        </div>
        {itens.length === 0 ? (
          <div className="caixa-detalhes-empty">
            <IonIcon icon={informationCircleOutline} aria-hidden="true" />
            <h3>Nenhum registro neste caixa</h3>
            <p>Os registros do caixa selecionado serão exibidos aqui.</p>
          </div>
        ) : (
          <table className="caixa-detalhes-table" aria-label="Detalhes do caixa">
            <thead>
              <tr>
                <th scope="col">Data e hora</th>
                <th scope="col">Tipo</th>
                <th scope="col">Cliente</th>
                <th scope="col" className="caixa-detalhes-value">Valor</th>
                <th scope="col" className="caixa-detalhes-chevron" aria-label="Imprimir comprovante" />
              </tr>
            </thead>
            <tbody>
              {itens.map((value: any) => (
                <tr key={"detalhes" + value.pk}
                  tabIndex={0}
                  aria-label={`Imprimir comprovante de ${value.clienteNome || 'cliente não informado'}`}
                  onClick={() => {
                    imprimirCupomDetalhe(value);
                  }}
                  onKeyDown={(event) => {
                    if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
                      event.preventDefault();
                      imprimirCupomDetalhe(value);
                    }
                  }}>
                  <td className="caixa-detalhes-date">
                    <span>{value.dataCadastro ? new Date(value.dataCadastro).toLocaleDateString('pt-BR') : ''}</span>
                    <small>{value.dataCadastro ? new Date(value.dataCadastro).toLocaleTimeString('pt-BR') : ''}</small>
                  </td>
                  <td className="caixa-detalhes-type">
                    {value.tipo === "caixa"
                      ? "Balcão"
                      : value.tipo === "projeto"
                        ? (window.localStorage.getItem("servicoTipoPlural") || "Projetos")
                        : value.tipo === "comandas"
                          ? (window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas")
                          : value.tipo === "totem"
                            ? "Totem"
                            : value.tipo.toUpperCase()}
                  </td>
                  <td className="caixa-detalhes-client">{value.clienteNome}</td>
                  <td className="caixa-detalhes-value">
                    R$ {value.valorTotal?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                  <td className="caixa-detalhes-chevron">
                    <IonIcon icon={chevronForwardOutline} aria-hidden="true" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    );
  }

  async function carregarProjetoImpressao(projetoid: any) {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const resp = await fetch(urlBaseCore.url + "/ordens/" + projetoid.replaceAll(/#/g, "%23") + "/semassinar",
      {
        method: urlBaseCore.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const response = await resp.json();
    return response?.Item;
  }

  async function imprimirCupomDetalhe(item: any) {
    try {
      setShowLoading(true);

      const projetoImpressao = await carregarProjetoImpressao(item.pk);
      const quantidadeImpressoes = dadosEmpresa?.impressaoDuasVias ? 2 : 1;

      const comandosEscPos = projetoImpressao ? gerarEscPos(
        projetoImpressao,
        dadosEmpresa?.impressoraLargura === "58",
        dadosEmpresa?.tamanhoFonte === "grande"
      ) : null;

      if (comandosEscPos) {
        const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

        let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
        let config: any = {};

        if (impressoraRedeHabilitar && mobile) {
          tipo = 'rede';
          config = { ip: dadosEmpresa?.impressoraRedeIp, porta: dadosEmpresa?.impressoraRedePorta };
        } else if (impressoraLocalHabilitar && !mobile) {
          tipo = 'local';
          config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
        } else if (impressoraBluetoothHabilitar && mobile) {
          tipo = 'ble';
          config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
        } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
          tipo = 'spp';
          config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
        }

        if (tipo) {
          const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
            comandosEscPos,
            dados: projetoImpressao,
            impressoraConfig: config,
            tipo,
            quantidadeVias: quantidadeImpressoes,
            origem: 'CaixaGeral:imprimirDetalhe'
          }));

          if (adicionado) {
            console.log('📋 [CAIXA GERAL] Cupom adicionado na fila');
            return;
          }
        }
      }
    } catch (error) {
      console.error("Erro ao imprimir cupom pela fila:", error);
    } finally {
      setShowLoading(false);
    }

    if (item.tipo === "projeto") {
      gerarCupomOrdens(item.pk);
    } else {
      gerarCupom(item.pk);
    }
  }


  async function gerarCupomOrdens(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    console.log("projetoid", projetoid);

    try {
      setShowLoading(true);
      const resp = await fetch(projetoGerarCupom.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
        {
          method: projetoGerarCupom.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      const result = await resp.json();
      if (result) {
        console.log("result", result);

        mostartAlerta({
          backdropDismiss: false,
          header: 'Gerar Cupom',
          message: '<strong>Cupom</strong> foi gerado com sucesso.',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Visualizar',
              cssClass: 'primary',
              handler: () => {
                window.open(result, '_blank');
              }
            }
          ],
          onDidDismiss: (e) => console.log('did dismiss'),
        })

      }

    } catch (error) {
      console.error("Erro ao gerar cupom:", error);
      setTextToast("Ocorreu um erro ao encontrar o detalhe.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  async function gerarCupom(comandaid: any) {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof tkn === "string") { token = tkn; }
    console.log("comandaid", comandaid);

    try {
      setShowLoading(true);
      const resp = await fetch(mesaGerarCupom.url.replaceAll("{id}", comandaid.replaceAll(/#/g, "%23")), {
        method: mesaGerarCupom.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
      const result = await resp.json();
      if (result) {
        console.log("result", result);

        mostartAlerta({
          backdropDismiss: false,
          header: 'Gerar Cupom',
          message: '<strong>Cupom</strong> foi gerado com sucesso.',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Visualizar',
              cssClass: 'primary',
              handler: () => {
                window.open(result, '_blank');
              }
            }
          ],
          onDidDismiss: (e) => console.log('did dismiss'),
        });
      }
    } catch (error) {
      console.error("Erro ao gerar cupom:", error);
      setTextToast("Ocorreu um erro ao encontrar o detalhe.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <IonPage className="caixa-geral-page">
      <IonHeader className="ion-no-border">

        <IonToolbar className="caixa-geral-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => {
              if (isMobileApp && mostrarDetalheMobile) {
                setMostrarDetalheMobile(false);
              } else {
                history.goBack();
              }
            }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Caixa geral</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="caixa-geral-container">
          <div className="caixa-geral-heading">
            <h1>Caixa geral</h1>
            <p>Acompanhe o histórico, os saldos e as movimentações do caixa da sua empresa.</p>
          </div>
          <IonGrid className="caixa-geral-layout">
            <IonRow>
              <IonCol className="caixa-geral-history-column" size='12' sizeMd='4' hidden={isMobileApp && mostrarDetalheMobile}>
                <section className="caixa-geral-panel caixa-geral-history">
                  <IonItem className="caixa-geral-panel-heading" lines="none">
                    <IonLabel>
                      <h2>Histórico</h2>
                      <p>Registro de caixas da empresa</p>
                    </IonLabel>
                    <IonButton aria-label="Filtrar caixas por data" className="caixa-geral-filter" size="small" fill='clear' slot='end' id='btn-filtro-data-caixa' onClick={() => {
                      setDataFiltroTemp(dataFiltro ? `${dataFiltro}T00:00 :00` : new Date().toISOString());
                      setShowFiltroData(true);
                    }}>
                      <IonIcon icon={filterOutline} />
                    </IonButton>
                  </IonItem>
                  {dataFiltro && (
                    <div style={{ padding: '8px 12px 0 12px' }}>
                      <IonChip color='primary' outline>
                        <IonIcon icon={calendarOutline} />
                        <IonLabel>{new Date(`${dataFiltro}T12:00:00`).toLocaleDateString('pt-BR')}</IonLabel>
                        <IonIcon icon={closeCircle} onClick={() => {
                          setDataFiltro(null);
                          carregarCaixas(null);
                        }} />
                      </IonChip>
                    </div>
                  )}
                  <IonPopover trigger='btn-filtro-data-caixa' isOpen={showFiltroData} onDidDismiss={() => setShowFiltroData(false)}>
                    <IonDatetime
                      presentation='date'
                      value={dataFiltroTemp}
                      onIonChange={(e) => {
                        const val = e.detail.value as string;
                        if (val) setDataFiltroTemp(val);
                      }}
                    />
                    <IonGrid>
                      <IonRow>
                        <IonCol>
                          <IonButton expand='block' fill='clear' onClick={() => setShowFiltroData(false)}>Cancelar</IonButton>
                        </IonCol>
                        <IonCol>
                          <IonButton expand='block' onClick={() => {
                            const dataSelecionada = (dataFiltroTemp || new Date().toISOString()).substring(0, 10);
                            setDataFiltro(dataSelecionada);
                            setShowFiltroData(false);
                            carregarCaixas(dataSelecionada);
                          }}>Aplicar</IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonPopover>
                  <div className="caixa-geral-open">
                    <IonButton hidden={stateCaixas?.Items?.some((item: any) => item.status === 'aberto') || !!dataFiltro || false}
                      disabled={acessos?.caixa != 'edicao'}
                      color="success"
                      expand='block'
                      size='large'
                      onClick={() => {
                        setShowModal(true);
                      }}>Quero abrir meu Caixa</IonButton>
                  </div>
                  <div className="caixa-geral-history-list">
                    {
                      stateCaixas.Items && stateCaixas.Items.map((item: any) => {
                        return (
                          <IonItem key={item.sk} detail button lines='none'
                            className={`caixa-geral-history-row${item.sk === stateCaixaSelecionado.sk ? ' is-selected' : ''}`}
                            aria-current={item.sk === stateCaixaSelecionado.sk ? 'true' : undefined}
                            onClick={() => {
                              console.log("item", item);
                              carregarCaixaGeral(item.sk);
                              setStateCaixaSelecionado(item);
                              if (isMobileApp) {
                                setMostrarDetalheMobile(true);
                              }
                            }}
                          >
                            <IonLabel>
                              <div style={{ fontWeight: 600, fontSize: 15 }}>
                                {new Date(item.dataAbertura).toLocaleDateString('pt-BR')}
                              </div>
                              <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                                {new Date(item.dataAbertura).toLocaleTimeString('pt-BR')}
                              </div>
                            </IonLabel>
                            <IonChip slot='end' className={`caixa-geral-status ${item.status === 'fechado' ? 'is-closed' : 'is-open'}`}>
                              {item.status}
                            </IonChip>
                          </IonItem>
                        );
                      })
                    }
                  </div>
                </section>
              </IonCol>
              <IonCol className="caixa-geral-summary-column" size='12' sizeMd='8' hidden={isMobileApp && !mostrarDetalheMobile}>
                <section className="caixa-geral-panel caixa-geral-summary">
                  <IonItem className="caixa-geral-panel-heading" lines='none' detail={true} onClick={() => {
                    setShowModalDetalhes(true);
                  }} button>
                    <IonLabel>
                      <h2>Resumo do caixa</h2>
                      <p>Acompanhamento do caixa da empresa</p>
                    </IonLabel>
                    <IonLabel className="caixa-geral-details-link" slot='end'>Detalhes</IonLabel>
                  </IonItem>
                  {!resumoFinanceiro && !showLoading && <p role="status">Selecione um caixa ou atualize para carregar os valores.</p>}
                  <div className="caixa-geral-summary-body" hidden={!resumoFinanceiro}>
                    {/* <IonItem lines='none' hidden={true}>
                  <IonLabel><b>Ações no caixa</b></IonLabel>
                  <IonChip color='success'>
                    <IonLabel>Suprimento</IonLabel>
                    <IonIcon icon={addCircle}></IonIcon>
                  </IonChip>
                  <IonChip color='danger'>
                    <IonLabel>Sangria</IonLabel>
                    <IonIcon src={removeCircle}></IonIcon>
                  </IonChip>
                </IonItem> */}

                    <div style={{ paddingTop: "10px" }}>
                      <IonGrid className="caixa-geral-metadata">
                        <IonRow>
                          <IonCol>Status</IonCol>
                          <IonCol size='8'><span className={`caixa-geral-status ${stateCaixaSelecionado.status === 'aberto' ? 'is-open' : 'is-closed'}`}>{stateCaixaSelecionado.status}</span></IonCol>
                        </IonRow>
                        <IonRow>
                          <IonCol>Abertura</IonCol>
                          <IonCol size='8'>{stateCaixaSelecionado.dataAbertura && new Date(stateCaixaSelecionado.dataAbertura).toLocaleString("en-GB")}</IonCol>
                        </IonRow>
                        <IonRow hidden={stateCaixaSelecionado.dataFechamento ? false : true}>
                          <IonCol>Fechamento</IonCol>
                          <IonCol size='8'>{stateCaixaSelecionado.dataFechamento && new Date(stateCaixaSelecionado.dataFechamento).toLocaleString("en-GB")}</IonCol>
                        </IonRow>
                      </IonGrid>




                      {/* Novos indicadores e avisos temporariamente ocultos; dados e cálculos permanecem ativos.
                  {resumoFinanceiro && <div className="caixa-geral-conciliacao">
                    <p>Recebimentos registrados: <strong>{Number(resumoFinanceiro.recebido).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></p>
                    <p>Em aberto identificado: <strong>{Number(resumoFinanceiro.emAberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong> · Recebido a mais identificado: <strong>{Number(resumoFinanceiro.recebidoAMais).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></p>
                    {resumoFinanceiro.qualidade?.pagamentosEstimados > 0 && <p>{resumoFinanceiro.qualidade.pagamentosEstimados} venda(s) sem valor recebido separado usam o total vendido como referência; diferenças não podem ser confirmadas.</p>}
                    {resumoFinanceiro.qualidade?.pagamentosInconsistentes > 0 && <p role="alert">Existem pagamentos ou trocos inconsistentes. Confira antes de fechar o caixa.</p>}
                  </div>}
                  */}
                      <div className="caixa-geral-metrics">
                        <div className="caixa-geral-metric">
                          <span className="caixa-geral-metric-icon is-orange"><IonIcon icon={cartOutline} aria-hidden="true" /></span>
                          <div className="caixa-geral-metric-text">
                            <span className="caixa-geral-metric-label">Vendas</span>
                            <strong>{"R$ " + Number(stateTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                          </div>
                        </div>
                        <div className="caixa-geral-metric">
                          <span className="caixa-geral-metric-icon is-green"><IonIcon icon={walletOutline} aria-hidden="true" /></span>
                          <div className="caixa-geral-metric-text">
                            <span className="caixa-geral-metric-label">Abertura</span>
                            <strong>{"R$ " + Number(resumoFinanceiro?.abertura || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                          </div>
                        </div>
                        <button type="button" className="caixa-geral-metric caixa-geral-metric-link" aria-label="Ver lançamentos" onClick={() => setShowModalLancamentos(true)}>
                          <span className="caixa-geral-metric-icon is-amber"><IonIcon icon={swapVerticalOutline} aria-hidden="true" /></span>
                          <span className="caixa-geral-metric-text">
                            <span className="caixa-geral-metric-label">Lançamentos</span>
                            <strong>{"R$ " + Number(stateSaldoLancamentos || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                          </span>
                          <IonIcon className="caixa-geral-metric-chevron" icon={chevronForwardOutline} aria-hidden="true" />
                        </button>
                        <div className="caixa-geral-metric">
                          <span className="caixa-geral-metric-icon is-purple"><IonIcon icon={cashOutline} aria-hidden="true" /></span>
                          <div className="caixa-geral-metric-text">
                            <span className="caixa-geral-metric-label">Dinheiro</span>
                            <strong>{"R$ " + Number(saldoDinheiro).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                          </div>
                        </div>
                      </div>

                      <IonGrid className="caixa-geral-actions" aria-label="Movimentações e impressão">

                        {/* Botões principais */}
                        <IonRow>


                          <IonCol size="6" sizeMd="3" hidden={!(stateCaixaSelecionado.status == 'aberto')}>
                            <IonButton
                              color='success'
                              expand='block'
                              disabled={acessos?.caixa != 'edicao'}
                              size='large'
                              onClick={() => {
                                setShowModalEntrada(true);
                              }}
                            >
                              + Entrada
                            </IonButton>
                          </IonCol>

                          <IonCol size="6" sizeMd="3" hidden={!(stateCaixaSelecionado.status == 'aberto')}>
                            <IonButton
                              color='warning'
                              expand='block'
                              disabled={acessos?.caixa != 'edicao'}
                              size='large'
                              onClick={() => {
                                setShowModalSaida(true);
                              }}
                            >
                              - Saída
                            </IonButton>
                          </IonCol>

                          <IonCol size="12" sizeMd={stateCaixaSelecionado.status == 'aberto' ? "6" : "12"}>
                            <IonButton
                              className="caixa-geral-print" fill="outline"
                              expand='block'
                              disabled={!(acessos?.caixa === 'edicao' || acessos?.caixa === 'leitura') || !stateCaixaSelecionado?.sk}
                              size='large'
                              onClick={imprimirFechamentoCaixa}
                            >
                              <IonIcon slot="start" icon={printOutline} />
                              Imprimir
                            </IonButton>
                          </IonCol>


                        </IonRow>
                      </IonGrid>

                      <IonItem className="caixa-geral-table-heading" lines="none">
                        <IonLabel>
                          Total por tipo de venda
                        </IonLabel>
                      </IonItem>
                      <div className='caixaGeralTabelaCaixa'>


                        <IonGrid className='lancamentos'>

                          <IonRow hidden={stateTotalBalcao == 0}>
                            <IonCol>Balcão</IonCol>
                            <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalBalcao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                          </IonRow>

                          <IonRow hidden={stateTotalMesa == 0}>
                            <IonCol>Mesa</IonCol>
                            <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalMesa).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                          </IonRow>

                          <IonRow hidden={stateTotalOrdens == 0}>
                            <IonCol>{(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonCol>
                            <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalOrdens).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                          </IonRow>

                          <IonRow hidden={stateTotalTotem == 0}>
                            <IonCol>Totem</IonCol>
                            <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateTotalTotem).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                          </IonRow>

                        </IonGrid>

                      </div>

                      <IonItem className="caixa-geral-table-heading" lines="none">
                        <IonLabel>
                          Total por forma de pagamento
                        </IonLabel>
                      </IonItem>
                      <div className='caixaGeralTabelaCaixa'>
                        {/* <IonGrid className='lancamentos'>


                      <IonRow hidden={stateDinheiro == 0}>
                        <IonCol>Dinheiro</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateDinheiro).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateCartaoCredito == 0}>
                        <IonCol>Cartão de Crédito</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateCartaoCredito).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateCartaoDebito == 0}>
                        <IonCol>Cartão de Débito</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateCartaoDebito).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={statePix == 0}>
                        <IonCol>Pix</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(statePix).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateAlelo == 0}>
                        <IonCol>Alelo</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateAlelo).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateSodexo == 0}>
                        <IonCol>Sodexo</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateSodexo).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateValeAlimentacao == 0}>
                        <IonCol>Vale Alimentação</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateValeAlimentacao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateBoleto == 0}>
                        <IonCol>Boleto</IonCol>

                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateBoleto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                      <IonRow hidden={stateSemDefinicao == 0}>
                        <IonCol>Sem Definição</IonCol>
                        <IonCol style={{ textAlign: "right" }}>{"R$ " + Number(stateSemDefinicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonCol>
                      </IonRow>

                    </IonGrid> */}

                        <IonGrid className="lancamentos">
                          {Object.entries(statePagamentos).map(([nome, valor]) => (
                            valor > 0 && (
                              <IonRow key={nome}>
                                <IonCol>{nome}</IonCol>
                                <IonCol style={{ textAlign: "right" }}>
                                  {"R$ " + Number(valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </IonCol>
                              </IonRow>
                            )
                          ))}
                        </IonGrid>

                      </div>
                    </div>
                  </div>
                  <div className="caixa-geral-closing" hidden={!(stateCaixaSelecionado.status == 'aberto')}>
                    <div><h3>Encerramento do caixa</h3><p>Finalize o caixa após conferir as movimentações.</p></div>
                    <IonButton
                      color='danger'
                      expand='block'
                      disabled={acessos?.caixa != 'edicao'}
                      size='large'
                      onClick={() => {
                        mensagemFecharCaixa();
                      }}
                    >
                      Fechar Caixa
                    </IonButton>
                  </div>
                </section>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>

        <IonModal className="caixa-geral-modal" isOpen={showModal} onDidDismiss={() => { setShowModal(false); }}>
          <CaixaGeralAbrir closeAction={closeModalSuccess} closeActionSimple={closeModal}></CaixaGeralAbrir>
        </IonModal>

        <IonModal className="fullscreen-modal caixa-geral-modal" isOpen={showModalDetalhes} onDidDismiss={() => { setShowModalDetalhes(false); }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Detalhes</IonTitle>
              <IonButtons slot="start" onClick={() => setShowModalDetalhes(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {readListaDetalhes()}
          </IonContent>
        </IonModal>

        <IonModal className="caixa-geral-modal" isOpen={showModalEntrada} onDidDismiss={() => {
          setShowModalEntrada(false);
          setValorEntrada('');
          setDescricaoEntrada('');
          setAlertaValorEntrada(false);
          setAlertaDescricaoEntrada(false);
        }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Nova Entrada</IonTitle>
              <IonButtons slot="start" onClick={() => {
                setShowModalEntrada(false);
                setValorEntrada('');
                setDescricaoEntrada('');
                setAlertaValorEntrada(false);
                setAlertaDescricaoEntrada(false);
              }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <div className="caixa-geral-field">
              <IonLabel>Descrição*</IonLabel>
              <IonInput aria-label="Descrição*"
                placeholder="Digite a descrição"
                value={descricaoEntrada}
                onIonChange={(e) => {
                  setDescricaoEntrada(e.detail.value!);
                  setAlertaDescricaoEntrada(false);
                }}
              />
            </div>

            <div className="caixa-geral-field">
              <IonLabel>Valor*</IonLabel>
              <IonInput aria-label="Valor*"
                type="tel"
                maxlength={14}
                placeholder="Digite o valor"
                value={valorEntrada}
                onKeyUp={onChangeValorEntrada}
              />
            </div>

            <IonItem lines="none">
              <IonIcon hidden={!alertaValorEntrada && !alertaDescricaoEntrada} size="large" slot="start" icon={alertCircle} color="danger" />
              <IonLabel hidden={!alertaValorEntrada && !alertaDescricaoEntrada} color="danger" style={{ fontSize: "14px" }}>Campo obrigatório</IonLabel>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonButton expand="block" size='large' color="primary" onClick={salvarEntrada}>
                Salvar
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal className="caixa-geral-modal" isOpen={showModalSaida} onDidDismiss={() => {
          setShowModalSaida(false);
          setValorSaida('');
          setDescricaoSaida('');
          setAlertaValorSaida(false);
          setAlertaDescricaoSaida(false);
        }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Nova Saída</IonTitle>
              <IonButtons slot="start" onClick={() => {
                setShowModalSaida(false);
                setValorSaida('');
                setDescricaoSaida('');
                setAlertaValorSaida(false);
                setAlertaDescricaoSaida(false);
              }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <div className="caixa-geral-field">
              <IonLabel>Descrição*</IonLabel>
              <IonInput aria-label="Descrição*"
                placeholder="Digite a descrição"
                value={descricaoSaida}
                onIonChange={(e) => {
                  setDescricaoSaida(e.detail.value!);
                  setAlertaDescricaoSaida(false);
                }}
              />
            </div>

            <div className="caixa-geral-field">
              <IonLabel>Valor*</IonLabel>
              <IonInput aria-label="Valor*"
                type="tel"
                maxlength={14}
                placeholder="Digite o valor"
                value={valorSaida}
                onKeyUp={onChangeValorSaida}
              />
            </div>

            <IonItem lines="none">
              <IonIcon hidden={!alertaValorSaida && !alertaDescricaoSaida} size="large" slot="start" icon={alertCircle} color="danger" />
              <IonLabel hidden={!alertaValorSaida && !alertaDescricaoSaida} color="danger" style={{ fontSize: "14px" }}>Campo obrigatório</IonLabel>
            </IonItem>
          </IonContent>
          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonButton expand="block" size='large' color="primary" onClick={salvarSaida}>
                Salvar
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal className="fullscreen-modal caixa-geral-modal" isOpen={showModalLancamentos} onDidDismiss={() => { setShowModalLancamentos(false); }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Lançamentos</IonTitle>
              <IonButtons slot="start" onClick={() => setShowModalLancamentos(false)}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonGrid style={{ padding: '0px', margin: '0px' }}>
              <IonRow>
                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Total de Entradas</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          {"R$ " + stateLancamentos
                            .filter((l: any) => l.tipo === 'entrada')
                            .reduce((sum: number, l: any) => sum + Math.abs(l.valor), 0)
                            .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>

                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Total de Saídas</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          {"R$ " + stateLancamentos
                            .filter((l: any) => l.tipo === 'saida')
                            .reduce((sum: number, l: any) => sum + Math.abs(l.valor), 0)
                            .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>

                <IonCol size="12" sizeMd='4'>
                  <IonCard style={{ padding: '0px', margin: '0px' }}>
                    <IonCardContent>
                      <div style={{ fontSize: "14px" }}>
                        <IonLabel>
                          <b>Saldo</b>
                        </IonLabel>
                      </div>
                      <div style={{ fontSize: "20px", marginTop: "8px" }}>
                        <IonLabel>
                          <b>{"R$ " + stateSaldoLancamentos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                        </IonLabel>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              </IonRow>
            </IonGrid>

            <IonItem lines='full' >
              <IonLabel>
                <b>Detalhes</b>
              </IonLabel>
            </IonItem>

            <IonList>
              {stateLancamentos.length === 0 ? (
                <IonItem>
                  <IonLabel className="ion-text-center" color="medium">
                    Nenhum lançamento registrado
                  </IonLabel>
                </IonItem>
              ) : (
                stateLancamentos.map((lancamento: any, index: number) => (
                  <IonItem key={`lancamento-detail-${index}`} lines="full">
                    <IonLabel>
                      <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                        {lancamento.data ? new Date(lancamento.data).toLocaleString('pt-BR').replace(',', '') : ''}
                      </p>
                      <h3 style={{ margin: '4px 0' }}>{lancamento.descricao}</h3>

                      <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: lancamento.valor > 0 ? '#2dd36f' : '#eb445a' }}>
                        {lancamento.valor > 0 ? '+' : '-'} R$ {Math.abs(lancamento.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                    </IonLabel>
                  </IonItem>
                ))
              )}
            </IonList>
          </IonContent>
        </IonModal>

      </IonContent>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />

      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />
    </IonPage>
  );
};

export default CaixaGeral;
